export enum BonusPointsTypes {
    BluePoints = 10,
    GoldenPoints = 11,
}
